import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';
import { DynamicStats } from '../models/entity-model-customization.model';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig,
  ) {
    this.pathApi = this.config.pathApi + 'customer/';
  }

  getStatsDynamic(obj: DynamicStats): Observable<any> {
    return this.http.post(`${this.pathApi}getStatsDynamic`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
}
